// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:08:50.922Z
// Property: Shiloh Creek Apartments (ID: 6737460151192638)
// Collections: 23 amenities, 2 floorplans (live), 23 photos, 72 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192638",
  "property_external_id": "4871561",
  "property_zillow_url": "https://www.zillow.com/b/802-limestone-cir-russellville-ar-5hQMvR/",
  "property_apartments_url": "https://www.apartments.com/shiloh-creek-apartments-russellville-ar/581p97q",
  "property_google_business_url": "https://www.google.com/maps/place/Shiloh+Creek+Apartments/data=!4m2!3m1!1s0x0:0x6ba8c93bc6f347a2?sa=X&ved=2ahUKEwjij8qpyrySAxXv9AIHHdlvMEMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321118532",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "shiloh-creek-apartments",
  "property_name": "Shiloh Creek Apartments",
  "property_website_url": "https://www.livingatshilohcreek.com/",
  "property_domain": "https://www.livingatshilohcreek.com/",
  "property_address": "802 Limestone Cir",
  "property_full_address": "802 Limestone Cir, Russellville, AR 72802",
  "property_address_1": "802 Limestone Cir",
  "property_address_2": null,
  "property_address_city": "Russellville",
  "property_address_state": "AR",
  "property_address_zip_full": "72802-7112",
  "property_address_zip": "72802",
  "property_address_country": "US",
  "property_address_county": "Pope County",
  "property_neighborhood_address": "Fort Smith/Russellville I-40",
  "property_address_latitude": "35.3128383",
  "property_address_longitude": "-93.1287775",
  "property_email": "shilohcreek@rreafresidential.com",
  "property_phone": "(479) 890-5454",
  "property_call_tracking_phone": "479-346-0967",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Shiloh Creek Apartments in Russellville, AR! Choose from spacious one and two-bedroom floor plans, and enjoy luxurious amenities like a refreshing pool, state-of-the-art fitness center, inviting clubhouse, business center, and serene courtyard. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "Welcome to Shiloh Creek Apartments, your ideal home in the heart of Russellville, AR! Offering a delightful selection of modern living spaces, our community features spacious one-bedroom and two-bedroom floor plans designed to meet your every need. Each apartment is crafted with comfort and style in mind, providing the perfect backdrop for your lifestyle.\n\nAt Shiloh Creek, residents enjoy an array of exceptional amenities that elevate everyday living. Dive into relaxation at our sparkling pool, or get your heart racing in our fully-equipped fitness center. When it's time to unwind, our inviting clubhouse is the perfect spot to socialize with neighbors or host gatherings. For those working from home, our business center ensures you have all the tools needed to stay productive. Step outside into our beautifully landscaped courtyard, where tranquility and nature come together for a peaceful retreat.\n\nLocated conveniently in Russellville, our community offers easy access to local shops, dining, and entertainment options, making it the perfect place to call home. Whether you're looking for a cozy one-bedroom space or a more spacious two-bedroom apartment, Shiloh Creek Apartments has something for everyone.\n\nDon't miss out on the opportunity to live in this vibrant community. Find your new home today—browse our availability or schedule a tour to experience the Shiloh Creek lifestyle firsthand! Your dream apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-54dd-73aa-b888-50ff8bd2fba1.webp",
  "property_featured_image_media": {
    "alt_text": "Modern lounge area with blue sofa, unique green chairs, and a coffee bar.",
    "public_id": "019e84a6-54dd-73aa-b888-50ff8bd2fba1",
    "storage_key": "property/6737460151192638/019e84a6-54dd-73aa-b888-50ff8bd2fba1.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "288",
  "property_year_built": "2002",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.91666666666666",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://shilohcreekapartments.loftliving.com/login",
  "property_apply_now_url": "https://8754825.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-9234-763c-99c2-9002d74bec9c.webp",
  "property_primary_logo_media": {
    "alt_text": "Shiloh Creek Apartments logo",
    "public_id": "019e1ddf-9234-763c-99c2-9002d74bec9c",
    "storage_key": "property/6737460151192638/019e1ddf-9234-763c-99c2-9002d74bec9c.webp",
    "width": 535,
    "height": 466
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-9243-7646-b177-c850c02a3e93.webp",
  "property_secondary_logo_media": {
    "alt_text": "Shiloh Creek Apartments logo",
    "public_id": "019e1ddf-9243-7646-b177-c850c02a3e93",
    "storage_key": "property/6737460151192638/019e1ddf-9243-7646-b177-c850c02a3e93.webp",
    "width": 535,
    "height": 466
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-9243-7646-b177-c850c02a3e93.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Shiloh Creek Apartments logo",
    "public_id": "019e1ddf-9243-7646-b177-c850c02a3e93",
    "storage_key": "property/6737460151192638/019e1ddf-9243-7646-b177-c850c02a3e93.webp",
    "width": 535,
    "height": 466
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a8-f4a6-75e8-ab39-5c8795d391ae.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e84a8-f4a6-75e8-ab39-5c8795d391ae",
    "storage_key": "property/6737460151192638/019e84a8-f4a6-75e8-ab39-5c8795d391ae.webp",
    "width": 535,
    "height": 466
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 925",
  "property_sqft_min": "650",
  "property_sqft_max": "925",
  "property_price_range": "735 - 1054",
  "property_price_min": "735",
  "property_price_max": "1054",
  "property_available_units": 6,
  "property_facebook_url": "https://facebook.com/p/Shiloh-Creek-Apartments-100075962839681",
  "property_instagram_url": "https://www.instagram.com/shiloh_creek_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJqfxXsfpSzIcRokfzxjvJqGs",
  "property_youtube_url": "https://www.youtube.com/watch?t=1&v=HvdpCHZnORk",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Russellville%2C+AR+72801",
  "property_tiktok_url": "https://www.tiktok.com/@shilohcreek",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Shiloh Creek Apartments",
  "property_home_romance_title": "Embrace Joyful Living in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Get away from it all and experience gracious <a href=\"/floor-plans/\">pet-friendly apartment living</a> at Shiloh Creek Apartments in Russellville, Arkansas. We are nestled in a beautiful forest setting, conveniently located less than 3 miles from Arkansas Tech University. Easy access to I-40 makes any commute in and around Pope County a breeze. You'll also find shopping, dining, entertainment venues, and Lake Dardanelle nearby. We offer pet-friendly one- and two-bedroom apartment homes for rent with features like fully equipped kitchens, in-home washer and dryer, and walk-in closets! Enjoy amazing amenities like two swimming pools, a business center, a clubhouse with frequent exclusive resident events, a laundry facility, a courtesy officer, and fitness center.</p>",
  "property_home_floorplans_blurb": "<p>Get away from it all and experience gracious <a href=\"/amenities/\">pet-friendly apartment</a> living at Shiloh Creek Apartments. We are nestled in a beautiful forest setting in Russellville, Arkansas, conveniently located less than 3 miles from Arkansas Tech University. Easy access to interstate 40 makes any commute in and around Pope County a breeze. You’ll also find shopping, dining, entertainment venues, and Lake Dardanelle nearby.</p>",
  "property_home_gallery_blurb": "At Shiloh Creek Apartments in Russellville, AR, your dream lifestyle awaits. Choose from spacious one and two-bedroom floor plans, complete with modern amenities like a fitness center, pool, and clubhouse. Picture yourself enjoying community perks like a gameroom and basketball court—your ideal home is here! ",
  "property_home_neighborhood_blurb": "Discover Shiloh Creek Apartments in Russellville, AR, where our spacious one and two-bedroom floor plans cater to your lifestyle. Explore our vibrant neighborhood and uncover local favorites, parks, and dining hotspots. See what's around our community and embrace the perfect blend of comfort and convenience today!",
  "property_home_reviews_blurb": "Welcome to Shiloh Creek Apartments in vibrant Russellville, AR! Our friendly management team is dedicated to making you feel at home, with updates that enhance your living experience. As one resident noted, “The staff are all great... everyone is always smiling,” making our community truly feel like family. Join us today!",
  "property_neighborhood_blurb": "<p>Get away from it all and experience gracious <a href=\"/amenities/\">pet-friendly apartment</a> living at Shiloh Creek Apartments. We are nestled in a beautiful forest setting in Russellville, Arkansas, conveniently located less than 3 miles from Arkansas Tech University. Easy access to interstate 40 makes any commute in and around Pope County a breeze. You’ll also find shopping, dining, entertainment venues, and Lake Dardanelle nearby.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Enjoy some of the finest services and amenities available in <a href=\"/floor-plans/\">apartment community living</a> in Russellville, AR. At Shiloh Creek Apartments, we have two shimmering swimming pools and a modern clubhouse. Staying in shape is made easy at the state-of-the-art fitness center. Rest assured, our dedicated team is here to help with any needs that may arise, so give us a call today and schedule a personal tour. We look forward to meeting you!</p>",
  "property_applynow_blurb": "Discover your perfect living space at Shiloh Creek Apartments in Russellville, AR! Choose from our stylish one and two-bedroom floor plans, and enjoy amenities like a refreshing pool, modern fitness center, and inviting clubhouse. Find your new home and lease online today! Explore all we have to offer!",
  "property_contactus_blurb": "Discover your ideal home at Shiloh Creek Apartments in Russellville, AR! Choose from our spacious one and two-bedroom floor plans that perfectly suit your lifestyle. View all available options and imagine your new life here. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "Discover your perfect home at Shiloh Creek Apartments in Russellville, AR! Explore our thoughtfully designed One and Two Bedroom floor plans tailored to your lifestyle. Have questions? Browse our FAQs page for answers on living in our vibrant community. Your ideal apartment awaits—start your journey today!",
  "property_floorplans_blurb": "<p>Shiloh Creek Apartments is proud to present five floor plans with spacious one and two bedroom apartments for rent. Our community offers the <a href=\"/amenities/\">amenities</a> you want and deserve, including a fully-equipped kitchen with a dishwasher and refrigerator where you can prepare great meals. We have anticipated your every need with walk-in closets and an in-home washer and dryer. Each detail has been considered with our residents in mind.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your ideal home at Shiloh Creek Apartments in Russellville, AR! Choose from spacious one and two-bedroom floor plans, and enjoy top-notch amenities like a refreshing pool, fitness center, clubhouse, business center, and serene courtyard. Use our interactive community map to explore available apartments and pricing today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Welcome to Shiloh Creek Apartments in Russellville, AR! Explore our spacious one and two-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy shared adventures in your new home! Discover your perfect space with us!",
  "property_residentaccess_blurb": "Welcome to Shiloh Creek Apartments in Russellville, AR! Explore our spacious one and two-bedroom floor plans designed for your comfort. Access your resident portal today to easily pay rent, schedule maintenance, and enjoy a hassle-free living experience. Unlock convenience at Shiloh Creek—your home awaits!",
  "property_reviews_blurb": "At Shiloh Creek Apartments in Russellville, AR, residents praise the welcoming atmosphere and attentive staff. \"The new management has absolutely made this community a family,\" says one satisfied tenant. With clean, spacious apartments and thoughtful amenities, it's no wonder our residents feel right at home. See what our residents have to say!",
  "property_created_at": "1752257257229",
  "property_scheduletour_blurb": "Experience the comfort of Shiloh Creek Apartments in Russellville, AR, featuring spacious one and two-bedroom floor plans designed for modern living. Explore our community and see what our residents have to say! Schedule a tour today to discover your ideal home at Shiloh Creek.",
  "property_thankyou_blurb": "Thank you for your interest in Shiloh Creek Apartments in Russellville, AR! Explore our spacious one and two-bedroom floor plans designed for your comfort. A team member will contact you shortly to assist you further. Discover your new home today! View all options to find your perfect fit.",
  "property_virtualtours_blurb": "<p>Take a virtual tour of Shiloh Creek apartments in Russellville, AR. Experience our spacious floor plan layouts & modern amenities from the comfort of your home.</p>",
  "property_copyright": "2025 All Rights Reserved. Shiloh Creek Apartments",
  "property_seo_title_home": "Shiloh Creek Apartments | Apartments in Russellville, AR",
  "property_seo_description_home": "Discover your dream home at Shiloh Creek Apartments in Russellville, AR! Explore spacious one and two-bedroom floor plans, and enjoy exceptional amenities including a refreshing pool, fitness center, clubhouse, business center, and serene courtyard. Elevate your lifestyle and find your perfect apartment today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Russellville, AR",
  "property_seo_description_floorplans": "Discover your ideal living space at Shiloh Creek Apartments in Russellville, AR! Explore our range of thoughtfully designed floor plans, including cozy one-bedroom and spacious two-bedroom options. Browse our available apartment homes and find your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | Russellville, AR Apartments for Rent",
  "property_seo_description_amenities": "Discover your perfect home at Shiloh Creek Apartments in Russellville, AR! Choose from our spacious one and two-bedroom floor plans, designed for comfort and style. Enjoy top-notch amenities, including a refreshing pool, modern fitness center, inviting clubhouse, convenient business center, and serene courtyard. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Russellville, AR",
  "property_seo_description_gallery": "Discover the beauty of Shiloh Creek Apartments in Russellville, AR! Explore our stunning photo gallery showcasing our spacious one and two-bedroom floor plans and exceptional amenities, including a refreshing pool, state-of-the-art fitness center, inviting clubhouse, and dedicated business center. Enjoy the serene courtyard and envision your perfect lifestyle. Picture yourself living here today!",
  "property_seo_title_virtualtours": "Virtual Tours | Shiloh Creek Apartments Apartments",
  "property_seo_description_virtualtours": "Explore Shiloh Creek Apartments in Russellville, AR, where comfort meets convenience! Our virtual tour showcases spacious one and two-bedroom floor plans designed to suit your lifestyle. Discover your perfect home today and take a virtual tour of our community and apartments for rent!",
  "property_seo_title_interactivemap": "Interactive Map | Shiloh Creek Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Shiloh Creek Apartments in Russellville, AR! Explore our spacious one and two-bedroom floor plans, and enjoy a wealth of amenities including a refreshing pool, state-of-the-art fitness center, inviting clubhouse, productive business center, and serene courtyard. Use our interactive community map to find available apartments, view pricing, and take the first step toward your new lifestyle today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Russellville, AR",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood around Shiloh Creek Apartments in Russellville, AR! Explore our one and two-bedroom floor plans and see what's nearby, from local favorites to key points of interest. Experience the perfect blend of comfort and convenience—click to uncover all that our community has to offer!",
  "property_seo_title_contact": "Contact Us | Shiloh Creek Apartments",
  "property_seo_description_contact": "Discover the perfect home at Shiloh Creek Apartments in Russellville, AR! Explore our spacious one and two-bedroom floor plans designed for comfort and convenience. Have questions? Contact our leasing team today for more information!",
  "property_seo_title_faqs": "FAQs | Apartments in Russellville, AR",
  "property_seo_description_faqs": "Discover everything you need to know about Shiloh Creek Apartments in Russellville, AR! Our FAQs page provides answers to your questions about our spacious one- and two-bedroom floor plans, as well as our top-notch amenities like a refreshing pool, state-of-the-art fitness center, inviting clubhouse, efficient business center, and beautiful courtyard. Browse our FAQs now to learn how Shiloh Creek Apartments can be your perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Russellville, AR",
  "property_seo_description_reviews": "Discover the charm of Shiloh Creek Apartments in Russellville, AR! Explore our spacious floor plans, including one and two-bedroom options, and enjoy top-notch amenities like a refreshing pool, fitness center, clubhouse, business center, and a serene courtyard. Don’t just take our word for it—see what our residents have to say about their experiences living in our vibrant community! Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Russellville, AR",
  "property_seo_description_applynow": "Discover your perfect living space at Shiloh Creek Apartments in Russellville, AR! Explore our spacious one and two-bedroom floor plans, and enjoy resort-style amenities including a sparkling pool, state-of-the-art fitness center, inviting clubhouse, business center, and beautiful courtyard. Don’t wait—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Shiloh Creek Apartments",
  "property_seo_description_residentaccess": "\"Log into Shiloh Creek Apartments' resident portal for easy access to rent payment, maintenance scheduling, and essential community updates. Join our vibrant Russellville, AR community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Shiloh Creek Apartments",
  "property_seo_description_referafriend": "\"Join the welcoming community at Shiloh Creek Apartments in Russellville, AR! Refer a friend today and enjoy exclusive rewards. Discover how great friends make great neighbors—let's build a vibrant living experience together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Shiloh Creek Apartments",
  "property_seo_description_scheduletour": "Discover your ideal home at Shiloh Creek Apartments in Russellville, AR! Experience modern living and a vibrant community. Schedule a tour today to explore our stunning amenities and find your perfect apartment!",
  "property_seo_title_privacy": "Privacy Policy | Shiloh Creek Apartments",
  "property_seo_description_privacy": "Discover the commitment to your privacy at Shiloh Creek Apartments in Russellville, AR. Our privacy policy outlines how we protect your personal information while you enjoy our vibrant community. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Shiloh Creek Apartments",
  "property_seo_description_accessibility": "Discover Shiloh Creek Apartments in Russellville, AR, where we prioritize accessibility for all! Explore our comprehensive accessibility statement and see how we're committed to fostering an inclusive community. Join us in creating a welcoming environment for everyone. Read more today!",
  "property_seo_title_sitemap": "Sitemap | Shiloh Creek Apartments",
  "property_seo_description_sitemap": "Discover the pathways to your new home at Shiloh Creek Apartments in Russellville, AR. Explore our sitemap to find detailed information about our community, amenities, and available floor plans. Navigate easily and plan your visit now!",
  "property_seo_title_thankyou": "Thank You | Shiloh Creek Apartments",
  "property_seo_description_thankyou": "Thank you for your inquiry at Shiloh Creek Apartments in Russellville, AR! We appreciate your interest. One of our team members will reach out shortly to assist you in finding your perfect home. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Russellville, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293657986",
  "amenities": [
    {
      "id": "ec_1dfec09299b9e5f49ab230b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74c584a9bb574afac3d8a8c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb7683165d0ccfb76af8016a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af06e3158d2217134f5fd282",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b1fa82ec154cda300504296",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14362323d6f3ee56de4dcefb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c83d2fcf8ba511e2f832477",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77c694aa9cb4a4962879c81a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f81470017162150dfefe614b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c1e9eab7bb34958f5338516",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Two Shimmering Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a281d95ac7ac4490eef1f479",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12e779363aa588b4e8b13e71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5bda37c5c43244a2625ca9f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b0f31a19b10d31680771b01",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e581b0d340308446d6d9e726",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d09630f8ba68e132066ac245",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91daddf02264122278227462",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Faux Wood Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3cbc438d393d9bbb4c8fea1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Fully‑equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b3d8722e6f7c962c96d69c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c19aca9f73ce72981f5d3450",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d63a09d1f92010814a03a47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Some Paid Utilities*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6b95051eb32c68feaacbc92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bacbe3d0925a360f5492f4ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer in Home*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4cae9f42-be43-4952-a91c-7b0cf3feff5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e7cd-73ca-b511-e23273f31a8e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a cloudy day.",
        "public_id": "01a0e9de-e7cd-73ca-b511-e23273f31a8e",
        "storage_key": "property/6737460151192638/01a0e9de-e7cd-73ca-b511-e23273f31a8e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded areas. Perfect for a refreshing dip or soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a cloudy day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_632da3f2-69de-43f7-bcef-04363850adb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e65b-77de-b245-b3def62615e9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a0e9de-e65b-77de-b245-b3def62615e9",
        "storage_key": "property/6737460151192638/01a0e9de-e65b-77de-b245-b3def62615e9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for a refreshing dip on a warm day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c538e7b2-5757-4a98-9d4e-0d24955f7d24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e718-76aa-886d-ed77a3ee4117.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with treadmills, ellipticals, free weights, and a rowing machine.",
        "public_id": "01a0e9de-e718-76aa-886d-ed77a3ee4117",
        "storage_key": "property/6737460151192638/01a0e9de-e718-76aa-886d-ed77a3ee4117.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center. Featuring cardio machines, free weights, and strength training equipment for a complete workout experience.",
      "link": "",
      "alt_text": "Fully equipped fitness center with treadmills, ellipticals, free weights, and a rowing machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f7ff697-529b-4c27-aa37-49978698edb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-8871-7774-b27e-66cdce3547e9.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a blue sofa, unique lime green chairs, and a coffee station.",
        "public_id": "019e84a6-8871-7774-b27e-66cdce3547e9",
        "storage_key": "property/6737460151192638/019e84a6-8871-7774-b27e-66cdce3547e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring comfortable seating, a coffee bar, and vibrant artwork. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Modern lounge area with a blue sofa, unique lime green chairs, and a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_505a03b0-63a4-4c0a-bd65-01c6269a88dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e6dc-7459-bd8b-851f39649634.webp",
      "image_media": {
        "alt_text": "A communal area with two high-top tables and chairs, decorated with a portrait of Albert Einstein.",
        "public_id": "01a0e9de-e6dc-7459-bd8b-851f39649634",
        "storage_key": "property/6737460151192638/01a0e9de-e6dc-7459-bd8b-851f39649634.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a vibrant communal space perfect for socializing or quiet work, featuring stylish seating and eye-catching artwork.",
      "link": "",
      "alt_text": "A communal area with two high-top tables and chairs, decorated with a portrait of Albert Einstein.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30b5be3e-f9ae-457e-b5cc-59c0f7bebf94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e5e8-703e-82c3-f61a71a1fe89.webp",
      "image_media": {
        "alt_text": "Living room with brown leather sofas, an ottoman, and a ceiling fan.",
        "public_id": "01a0e9de-e5e8-703e-82c3-f61a71a1fe89",
        "storage_key": "property/6737460151192638/01a0e9de-e5e8-703e-82c3-f61a71a1fe89.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Cozy living room featuring plush brown leather seating, a decorative ottoman, and a stylish ceiling fan. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with brown leather sofas, an ottoman, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbd5ce05-3df4-4c97-9be3-7fd7406393a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e6a6-764a-96f2-aabc341406b7.webp",
      "image_media": {
        "alt_text": "Living room with leather furniture and stacked washer/dryer combo",
        "public_id": "01a0e9de-e6a6-764a-96f2-aabc341406b7",
        "storage_key": "property/6737460151192638/01a0e9de-e6a6-764a-96f2-aabc341406b7.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax in style in this spacious living area, complete with a stacked washer and dryer for ultimate convenience.",
      "link": "",
      "alt_text": "Living room with leather furniture and stacked washer/dryer combo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_350bdaad-708a-457b-a966-6bd60c8fcd0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e602-718a-9d72-2faa5c4c1c9a.webp",
      "image_media": {
        "alt_text": "Kitchen area with a small dining table and chairs, dark wood cabinets, sink, and refrigerator.",
        "public_id": "01a0e9de-e602-718a-9d72-2faa5c4c1c9a",
        "storage_key": "property/6737460151192638/01a0e9de-e602-718a-9d72-2faa5c4c1c9a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this compact kitchen featuring dark wood cabinetry, a double sink, and a convenient dining nook.",
      "link": "",
      "alt_text": "Kitchen area with a small dining table and chairs, dark wood cabinets, sink, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9aea6b7d-2db8-4233-8ba2-ca1bb2c9d244",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e815-74cf-97e7-263cc4cd18bd.webp",
      "image_media": {
        "alt_text": "Basketball court with a hoop, surrounded by green grass and trees, with apartment buildings in the background.",
        "public_id": "01a0e9de-e815-74cf-97e7-263cc4cd18bd",
        "storage_key": "property/6737460151192638/01a0e9de-e815-74cf-97e7-263cc4cd18bd.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our on-site basketball court. Perfect for a friendly game or getting some exercise, this amenity is available for all residents.",
      "link": "",
      "alt_text": "Basketball court with a hoop, surrounded by green grass and trees, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db4c3b4d-7636-4b44-9f0e-045865440378",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e607-73d0-a4c8-9bd35bb12af6.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines, dryers, and a vending machine.",
        "public_id": "01a0e9de-e607-73d0-a4c8-9bd35bb12af6",
        "storage_key": "property/6737460151192638/01a0e9de-e607-73d0-a4c8-9bd35bb12af6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with washing machines, dryers, and a vending machine for your needs. Save time and energy with easy access to laundry services.",
      "link": "",
      "alt_text": "Laundry room with multiple washing machines, dryers, and a vending machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da5c682c-7153-4545-9c58-0ca7b1d2379a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/01a0e9de-e65d-73ad-8a64-842d80bcf5de.webp",
      "image_media": {
        "alt_text": "Fenced dog park with agility equipment, including hoops and tunnels.",
        "public_id": "01a0e9de-e65d-73ad-8a64-842d80bcf5de",
        "storage_key": "property/6737460151192638/01a0e9de-e65d-73ad-8a64-842d80bcf5de.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, perfect for your furry friends to play and exercise in a safe, fenced environment.",
      "link": "",
      "alt_text": "Fenced dog park with agility equipment, including hoops and tunnels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_829d3ab1-33ef-46f0-8e04-377eed328325",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-7638-74b2-8b70-548b9cb5382b.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight machines",
        "public_id": "019e84a6-7638-74b2-8b70-548b9cb5382b",
        "storage_key": "property/6737460151192638/019e84a6-7638-74b2-8b70-548b9cb5382b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio machines, including treadmills and ellipticals, as well as weight training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and weight machines",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3576c90b-8c34-4ab3-be8d-6a8e0540ae13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-9871-739f-8160-64733098006c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas under a blue sky with white clouds.",
        "public_id": "019e84a6-9871-739f-8160-64733098006c",
        "storage_key": "property/6737460151192638/019e84a6-9871-739f-8160-64733098006c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable seating areas. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas under a blue sky with white clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fee602a8-d2ba-4f43-9e5b-d9737a5ae180",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-9ea7-709d-b0ba-2544a7b8afed.webp",
      "image_media": {
        "alt_text": "Kitchen with dark brown cabinets, black appliances, and wood-look flooring.",
        "public_id": "019e84a6-9ea7-709d-b0ba-2544a7b8afed",
        "storage_key": "property/6737460151192638/019e84a6-9ea7-709d-b0ba-2544a7b8afed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark brown cabinetry, a black dishwasher, stove, and refrigerator, complemented by wood-look vinyl plank flooring.",
      "link": "",
      "alt_text": "Kitchen with dark brown cabinets, black appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15686279-11bd-4883-bf5f-764e87a64c6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-6572-769d-9a75-5516bf45ca0c.webp",
      "image_media": {
        "alt_text": "Business center with computers and desks.",
        "public_id": "019e84a6-6572-769d-9a75-5516bf45ca0c",
        "storage_key": "property/6737460151192638/019e84a6-6572-769d-9a75-5516bf45ca0c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize our convenient business center, complete with computers and desks, for all your professional needs.",
      "link": "",
      "alt_text": "Business center with computers and desks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d6a951d-89e9-499f-930d-94a5b68e8f1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-7c11-71cf-ab9a-5d6c5d0a1777.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dual sinks and mirrors, bathtub, toilet, and dark wood cabinets.",
        "public_id": "019e84a6-7c11-71cf-ab9a-5d6c5d0a1777",
        "storage_key": "property/6737460151192638/019e84a6-7c11-71cf-ab9a-5d6c5d0a1777.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our well-appointed bathrooms, featuring modern vanities, spacious tubs, and ample storage.",
      "link": "",
      "alt_text": "Bathroom vanity with dual sinks and mirrors, bathtub, toilet, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d98305c-1764-4695-9739-4890770ba105",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-8404-73b6-991b-81630316dfd0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and ceiling fan.",
        "public_id": "019e84a6-8404-73b6-991b-81630316dfd0",
        "storage_key": "property/6737460151192638/019e84a6-8404-73b6-991b-81630316dfd0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant wooden dresser, and a modern ceiling fan for optimal comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7730d846-f076-472e-8fed-5716af370c1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-cf74-73b9-a908-84c8b4849f42.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with a swimming pool and lounge chairs.",
        "public_id": "019e84a6-cf74-73b9-a908-84c8b4849f42",
        "storage_key": "property/6737460151192638/019e84a6-cf74-73b9-a908-84c8b4849f42.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our vibrant community featuring a sparkling swimming pool, perfect for relaxing and enjoying the sunny weather. Surrounded by lush greenery and ample parking, this is resort-style living at its finest.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with a swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_577200b3-96e9-426a-8608-742b42c753c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-adec-736c-bdec-fe51734e6e99.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and tub/shower combo.",
        "public_id": "019e84a6-adec-736c-bdec-fe51734e6e99",
        "storage_key": "property/6737460151192638/019e84a6-adec-736c-bdec-fe51734e6e99.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Freshen up in the spacious bathroom, featuring a modern vanity, toilet, and a pristine tub/shower combo. In-unit laundry facilities are visible in the reflection.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and tub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2b6d1d3-19af-4c91-b599-2456e512f229",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-b523-72d6-b71c-1a215e2bb7a8.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, a closed door, and a window with blinds.",
        "public_id": "019e84a6-b523-72d6-b71c-1a215e2bb7a8",
        "storage_key": "property/6737460151192638/019e84a6-b523-72d6-b71c-1a215e2bb7a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a ceiling fan, plush carpeting, and a large window with blinds, offering a comfortable living space.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, a closed door, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a81fd3bd-4f48-49e6-857a-6b733adb5128",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-93a4-74f4-bb8c-03f903241562.webp",
      "image_media": {
        "alt_text": "Interior view of a vacant apartment bedroom with plush carpeting, a ceiling fan, and a window with blinds.",
        "public_id": "019e84a6-93a4-74f4-bb8c-03f903241562",
        "storage_key": "property/6737460151192638/019e84a6-93a4-74f4-bb8c-03f903241562.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom featuring soft carpeting, a ceiling fan for comfort, and a window providing natural light. An adjacent hallway offers a glimpse of the apartment's layout.",
      "link": "",
      "alt_text": "Interior view of a vacant apartment bedroom with plush carpeting, a ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce2a58e6-a672-413d-9c1b-e3dc57651f1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-8a43-74ed-a4d7-ef4e1f707b5f.webp",
      "image_media": {
        "alt_text": "Clean and bright bathroom with a white tub, toilet, and vanity with sink.",
        "public_id": "019e84a6-8a43-74ed-a4d7-ef4e1f707b5f",
        "storage_key": "property/6737460151192638/019e84a6-8a43-74ed-a4d7-ef4e1f707b5f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious bathroom featuring a white bathtub and shower, a modern toilet, and a vanity with a clean sink. A large mirror reflects the space, adding to its open feel.",
      "link": "",
      "alt_text": "Clean and bright bathroom with a white tub, toilet, and vanity with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c551232b-9776-4aa8-adef-a3b06725b877",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e84a6-8431-741c-abb7-18ed6ea37b96.webp",
      "image_media": {
        "alt_text": "Shiloh Creek apartment complex leasing office with brick exterior, manicured bushes, and blooming pink flowers.",
        "public_id": "019e84a6-8431-741c-abb7-18ed6ea37b96",
        "storage_key": "property/6737460151192638/019e84a6-8431-741c-abb7-18ed6ea37b96.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Shiloh Creek, where our leasing office awaits you. Admire the beautiful brick exterior and vibrant landscaping.",
      "link": "",
      "alt_text": "Shiloh Creek apartment complex leasing office with brick exterior, manicured bushes, and blooming pink flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_16ab3700-4575-4b7a-8439-320a55f1ef04",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Stoby's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "405 W Parkway Dr, Russellville, AR 72801, USA",
      "poi_short_description": "Long-running diner serving Southern-style American grub, including cheese dip & baked goods.",
      "poi_long_description": "Long-running diner serving Southern-style American grub, including cheese dip & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-4400-718c-97f1-480ec1be93f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-4400-718c-97f1-480ec1be93f6",
        "storage_key": "property/6737460151192638/019e1ddf-4400-718c-97f1-480ec1be93f6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://stobys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12810443980625869029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stobys-restaurant",
      "poi_latitude": "35.2810836",
      "poi_longitude": "-93.1356356",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-968-3816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8wdfqXVTzIcR5fg-gO3Wx7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a4f1ef05-b78e-4e1d-aab9-1d0acc7a4f9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Feltner's Whatta-Burger",
      "poi_type": "Restaurants",
      "poi_address": "1410 N Arkansas Ave, Russellville, AR 72801, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-57c0-77c8-8b46-c46e3de55004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-57c0-77c8-8b46-c46e3de55004",
        "storage_key": "property/6737460151192638/019e1de1-57c0-77c8-8b46-c46e3de55004.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/share/1AEb1prb3M/?mibextid=wwXIfr",
      "poi_directions_map_url": "https://maps.google.com/?cid=11149401657001044019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "feltners-whatta-burger",
      "poi_latitude": "35.2930399",
      "poi_longitude": "-93.132813",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-968-1410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWTe0ghTzIcRM-iyJ7yhupo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_4f4bd32c-07f2-4c84-a46c-7605a7b63b9b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "CJ's Butcher Boy Burgers",
      "poi_type": "Restaurants",
      "poi_address": "2803 N Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Freshly cut fries are prepared along with burgers & shakes at this '50s-style, counter-serve joint.",
      "poi_long_description": "Freshly cut fries are prepared along with burgers & shakes at this '50s-style, counter-serve joint.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-4077-7272-8473-a6a2e12e8400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-4077-7272-8473-a6a2e12e8400",
        "storage_key": "property/6737460151192638/019e1ddf-4077-7272-8473-a6a2e12e8400.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.butcherboyburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3701087925227063489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cjs-butcher-boy-burgers",
      "poi_latitude": "35.3081101",
      "poi_longitude": "-93.1390686",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 479-968-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5LXbVVSzIcRwYil2dvnXDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_54961aa0-9e62-49b3-9f7a-d317fabeb028",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Colton's Steak House & Grill",
      "poi_type": "Restaurants",
      "poi_address": "2320 N Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Easygoing steakhouse chain with a Wild West theme, offering complimentary peanuts.",
      "poi_long_description": "Easygoing steakhouse chain with a Wild West theme, offering complimentary peanuts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-5c4f-702a-81b2-7f92729f7822.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-5c4f-702a-81b2-7f92729f7822",
        "storage_key": "property/6737460151192638/019e1de1-5c4f-702a-81b2-7f92729f7822.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coltonssteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12356476659242359055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coltons-steak-house--grill",
      "poi_latitude": "35.303467",
      "poi_longitude": "-93.1372131",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-880-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRX23fwBTzIcRD9mL3Q0Ge6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_de426da9-dba7-40ec-865a-b4476b5ddae6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Fat Daddy's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "104 N Denver Ave, Russellville, AR 72801, USA",
      "poi_short_description": "Relaxed eatery dishing up barbeque classics like brisket and burgers, as well as beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-5b3d-725f-af3b-5e166db5f94b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-5b3d-725f-af3b-5e166db5f94b",
        "storage_key": "property/6737460151192638/019e1de1-5b3d-725f-af3b-5e166db5f94b.webp",
        "width": 850,
        "height": 1280
      },
      "poi_business_url": "http://www.fatdaddysbarbque.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13684545341506681766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fat-daddys-bar-b-que",
      "poi_latitude": "35.2793201",
      "poi_longitude": "-93.1358973",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-967-0420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2ZQ0HVTzIcRpns7-XtF6b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_bcffa2a7-0834-4647-acd4-008324bbbd5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Umami | Sushi & Grill",
      "poi_type": "Restaurants",
      "poi_address": "304 N Elmira Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Popular for both sushi and hibachi entrees, this family-friendly restaurant also has beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-5bf2-7362-8f62-34a48a2b7fe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-5bf2-7362-8f62-34a48a2b7fe5",
        "storage_key": "property/6737460151192638/019e1de1-5bf2-7362-8f62-34a48a2b7fe5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.ar-umami.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7744248834582228726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umami--sushi--grill",
      "poi_latitude": "35.2812635",
      "poi_longitude": "-93.1022165",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-967-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WmK20tTzIcR9q6BxUgZeWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_981e4837-b9d2-488e-b029-6915e11865aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Sumo Japanese Steakhouse & Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "2300 E Parkway Dr, Russellville, AR 72802, USA",
      "poi_short_description": "Eatery offering sushi, hibachi fare, and other Japanese dishes in a relaxed setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-5778-77d8-906a-6c976961e24f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-5778-77d8-906a-6c976961e24f",
        "storage_key": "property/6737460151192638/019e1de1-5778-77d8-906a-6c976961e24f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.sumorussellville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6947224064382626194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sumo-japanese-steakhouse--sushi-bar",
      "poi_latitude": "35.282093",
      "poi_longitude": "-93.1062164",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-880-8855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ54eRX0hTzIcRkmmShHp_aWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_093ca780-04cc-41b2-a8a8-7f03a2a0aa9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "A Downtown Taco Company",
      "poi_type": "Restaurants",
      "poi_address": "313 W B St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-593d-70af-ac18-4e2c382053c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-593d-70af-ac18-4e2c382053c3",
        "storage_key": "property/6737460151192638/019e1de1-593d-70af-ac18-4e2c382053c3.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://downtown-tacos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=856979810441858852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-downtown-taco-company",
      "poi_latitude": "35.2793568",
      "poi_longitude": "-93.1355779",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-567-5549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUXT1NNTzIcRJI8R3Zia5As",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d636c4c8-51c7-4289-9273-85575c97898e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "211 E Harrell Dr, Russellville, AR 72802, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-3fd0-72ef-be1d-af4361ba1f42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-3fd0-72ef-be1d-af4361ba1f42",
        "storage_key": "property/6737460151192638/019e1ddf-3fd0-72ef-be1d-af4361ba1f42.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ar/russellville/347/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=10044403982004593766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.3033525",
      "poi_longitude": "-93.133454",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-968-5983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4NbeAFTzIcRZiTnPzTkZIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ee29081c-cc6f-4072-bf8c-cc8393cd1686",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "3095 E Main St, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-5807-775e-833f-50e66a26eabc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-5807-775e-833f-50e66a26eabc",
        "storage_key": "property/6737460151192638/019e1de1-5807-775e-833f-50e66a26eabc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.chipotle.com/ar/russellville/3095-e-main-st?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=5357",
      "poi_directions_map_url": "https://maps.google.com/?cid=3627444807302066103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "35.2783519",
      "poi_longitude": "-93.0945672",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-251-8735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpUFOMTytzYcRty-TTdVFVzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_6ec8058d-e5b4-4136-bc0d-07888b92433a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Cicis Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2507 E Parkway Dr, Russellville, AR 72802, USA",
      "poi_short_description": "Italian chain offering an array of specialty pizzas, plus classic pastas & salads.",
      "poi_long_description": "Italian chain offering an array of specialty pizzas, plus classic pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-576b-75e0-b825-5413ef7ff2d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-576b-75e0-b825-5413ef7ff2d0",
        "storage_key": "property/6737460151192638/019e1de1-576b-75e0-b825-5413ef7ff2d0.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.cicis.com/locations/ar-russelville-2507-e-parkway-dr?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12396196503299748915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cicis-pizza",
      "poi_latitude": "35.2828694",
      "poi_longitude": "-93.1040422",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-219-4324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7HNrbSszYcRM_QeuQojCKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_4c1787a0-df51-4adb-b9a7-4c50f4cde2ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Nonna Bella’s Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "717 S Arkansas Ave, Russellville, AR 72801, USA",
      "poi_short_description": "Casual restaurant serving pizzas, spaghetti, lasagna, and other Italian dishes, plus desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-5acd-7640-9966-2eb796a7361c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-5acd-7640-9966-2eb796a7361c",
        "storage_key": "property/6737460151192638/019e1de1-5acd-7640-9966-2eb796a7361c.webp",
        "width": 1089,
        "height": 614
      },
      "poi_business_url": "http://nonnabellapizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485121654599775394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nonna-bellas-pizzeria",
      "poi_latitude": "35.2716842",
      "poi_longitude": "-93.1336231",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-317-1034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrR4_9D9TzIcRovQsoZeigpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_312c18cb-e5e7-43a8-922e-befe810c7998",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Pasta Grill Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "319 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Italian classics such as chicken parmesan and tiramisu served in a casual, cozy atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-606b-760a-980f-7b088c0b5672.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-606b-760a-980f-7b088c0b5672",
        "storage_key": "property/6737460151192638/019e1de1-606b-760a-980f-7b088c0b5672.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.pastagrillrussellville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8179067405004471182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pasta-grill-restaurant",
      "poi_latitude": "35.278409",
      "poi_longitude": "-93.1362174",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-967-1707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZykdnZTzIcRjntEZXjigXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_36675ab5-03d6-47fd-bb33-4a7f4a13d862",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "It's Just Wings",
      "poi_type": "Restaurants",
      "poi_address": "107 N Elmira Ave, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6072-75de-bcbc-fa3bca199c0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6072-75de-bcbc-fa3bca199c0d",
        "storage_key": "property/6737460151192638/019e1de1-6072-75de-bcbc-fa3bca199c0d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.itsjustwings.com/ar/russellville/russellville-its-just-wings?utm_source=google&utm_medium=local&utm_campaign=IJW",
      "poi_directions_map_url": "https://maps.google.com/?cid=9018809260621436019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "its-just-wings",
      "poi_latitude": "35.278534",
      "poi_longitude": "-93.103086",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-466-6983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXugkE9TzIcRcxRYJD0_KX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_2250de02-84b4-47f6-b3e4-46cc5c72d9d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2409 E Main St, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6507-777c-b996-84273d6ec33f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6507-777c-b996-84273d6ec33f",
        "storage_key": "property/6737460151192638/019e1de1-6507-777c-b996-84273d6ec33f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/58-russellville-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17444004533870029103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.2801425",
      "poi_longitude": "-93.1052985",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-967-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68af-719a-ba34-9b17419d536a",
        "storage_key": "property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlfmBIU9TzIcRL2mghbONFfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3c03d235-8084-4300-89b0-3706fe14653b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1109 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-3fc4-711b-af55-5ff323535657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-3fc4-711b-af55-5ff323535657",
        "storage_key": "property/6737460151192638/019e1ddf-3fc4-711b-af55-5ff323535657.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ar/russellville/russellville/025/00624?cid=loc_02500624_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16207550064955982409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "35.2795351",
      "poi_longitude": "-93.1435753",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-890-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68c7-727d-b027-93ad8589896f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68c7-727d-b027-93ad8589896f",
        "storage_key": "property/6737460151192638/019e1ddf-68c7-727d-b027-93ad8589896f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJial1IZlTzIcRSYIPrenI7OA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_453a2381-1143-4eb6-b2d2-87e99161392d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 E Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-628b-76c8-bfff-68c94bbf5a0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-628b-76c8-bfff-68c94bbf5a0d",
        "storage_key": "property/6737460151192638/019e1de1-628b-76c8-bfff-68c94bbf5a0d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/russellville-ar-pharmacies/101-east-main-street-russellville-ar-72801/storeid=11093?WT.mc_id=LS_GOOGLE_FS_11093",
      "poi_directions_map_url": "https://maps.google.com/?cid=15077900180215870124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "35.2784691",
      "poi_longitude": "-93.1332375",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-498-0014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbZZC_RNTzIcRrLKQ6FN2P9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_0d83f66f-6f36-4ba6-bab7-84d07a3d5987",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1100 E Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-650e-773c-a16e-0249e452d8d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-650e-773c-a16e-0249e452d8d0",
        "storage_key": "property/6737460151192638/019e1de1-650e-773c-a16e-0249e452d8d0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1100+e+main+st-russellville-ar-72801/id=10199",
      "poi_directions_map_url": "https://maps.google.com/?cid=14126261870106834924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.2779185",
      "poi_longitude": "-93.1196398",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-967-1573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9mYnGlTzIcR7Pfco1OQCsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8835daba-ed89-4217-9484-944cf3a2e749",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 S Knoxville Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-623d-76fe-991f-7862a38ee323.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-623d-76fe-991f-7862a38ee323",
        "storage_key": "property/6737460151192638/019e1de1-623d-76fe-991f-7862a38ee323.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://locations.familydollar.com/ar/russellville/1200-s-knoxville-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4989631023826150306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "35.2671219",
      "poi_longitude": "-93.1212584",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-453-0813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68af-719a-ba34-9b17419d536a",
        "storage_key": "property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOx2sL2FTzIcRoiNt3_q6PkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_406ee374-6058-47e4-9abd-bb5c388455c2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2910 N Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6547-77a0-a520-abc64de5c0ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6547-77a0-a520-abc64de5c0ee",
        "storage_key": "property/6737460151192638/019e1de1-6547-77a0-a520-abc64de5c0ee.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ar/russellville/14625",
      "poi_directions_map_url": "https://maps.google.com/?cid=4732670990389008663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.310496",
      "poi_longitude": "-93.1373078",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-507-0489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68af-719a-ba34-9b17419d536a",
        "storage_key": "property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD35P9lVSzIcRF9nu5DDTrUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_b7509617-575b-418b-a65d-0ab80c06ac6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Casey's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2803 S Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_long_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-67c4-7323-9aec-ff36415ac464.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-67c4-7323-9aec-ff36415ac464",
        "storage_key": "property/6737460151192638/019e1de1-67c4-7323-9aec-ff36415ac464.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.caseys.com/general-store/ar-russellville/2803-s-arkansas-ave/3755?utm_medium=organic&utm_source=google&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=1435827310663162860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caseys",
      "poi_latitude": "35.2499651",
      "poi_longitude": "-93.1360034",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-498-7495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVZxE4hUzIcR7Nvh6lQV7RM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5ef0359f-42e4-43bd-8a7a-2d1ae8f874d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "3051 E Main St, Russellville, AR 72802, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-670a-756c-be84-a435b19a6912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-670a-756c-be84-a435b19a6912",
        "storage_key": "property/6737460151192638/019e1de1-670a-756c-be84-a435b19a6912.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ar/russellville/3051-east-main-street?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3855259485915053047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "35.2785525",
      "poi_longitude": "-93.0977037",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-275-0041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68af-719a-ba34-9b17419d536a",
        "storage_key": "property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXdOiprOszYcR9_vrjhOigDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_604a8ea7-557d-4588-b6c9-846b5b5db225",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "E-Z Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "3102 S Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Convenience-store chain stocking coffee, bottled beverages & fountain drinks, plus candy & snacks.",
      "poi_long_description": "Convenience-store chain stocking coffee, bottled beverages & fountain drinks, plus candy & snacks.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.e-zmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5997738583020356275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-z-mart",
      "poi_latitude": "35.2465133",
      "poi_longitude": "-93.1389539",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-968-6371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c22-7177-8149-42055456fbb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c22-7177-8149-42055456fbb9",
        "storage_key": "property/6737460151192638/019e1de1-9c22-7177-8149-42055456fbb9.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJLdGUD2JUzIcRs0KVwHY_PFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_63ae5007-7167-4297-9ef2-510d555bcec4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2109 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Chain grocery store offering items such as toys, clothing, and furniture, as well as a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-420b-7619-96e7-87ef0891b499.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-420b-7619-96e7-87ef0891b499",
        "storage_key": "property/6737460151192638/019e1ddf-420b-7619-96e7-87ef0891b499.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.walmart.com/store/4128-russellville-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16915770567746990932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.2826341",
      "poi_longitude": "-93.1535785",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-498-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68c7-727d-b027-93ad8589896f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68c7-727d-b027-93ad8589896f",
        "storage_key": "property/6737460151192638/019e1ddf-68c7-727d-b027-93ad8589896f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYaaw5VTzIcRVDORMLXjwOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4a816051-3bae-47b5-937c-d47893fa9632",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Russellville High School",
      "poi_type": "Education",
      "poi_address": "2203 S Knoxville Ave, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-67c6-7438-8f20-51748af03831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-67c6-7438-8f20-51748af03831",
        "storage_key": "property/6737460151192638/019e1de1-67c6-7438-8f20-51748af03831.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "https://www.russellvilleschools.net/o/rhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=8370903478399967345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russellville-high-school",
      "poi_latitude": "35.2578473",
      "poi_longitude": "-93.1179535",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-968-3151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1dPmWZ5UzIcRcaAc11xsK3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3f64a621-9fdd-49e9-af9a-fd3565d094cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Russellville Junior High",
      "poi_type": "Education",
      "poi_address": "2000 W Parkway Dr, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.russellvilleschools.net/o/RJHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=7214520452335745654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russellville-junior-high",
      "poi_latitude": "35.2900503",
      "poi_longitude": "-93.1517634",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-968-1599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJscoO8rtTzIcRdjpDkiAgH2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_bdfd2efe-47d1-45ce-a8fe-16a242a9489d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Russellville Middle School",
      "poi_type": "Education",
      "poi_address": "1203 W 4th Pl, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-681d-7486-81cb-2068a041a60b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-681d-7486-81cb-2068a041a60b",
        "storage_key": "property/6737460151192638/019e1de1-681d-7486-81cb-2068a041a60b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.russellvilleschools.net/o/rms",
      "poi_directions_map_url": "https://maps.google.com/?cid=7501836030836289863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russellville-middle-school",
      "poi_latitude": "35.2738202",
      "poi_longitude": "-93.1454995",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-968-2557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs3hv_ZpTzIcRRzE5pR_gG2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_162aae6b-b953-44f5-bb6d-b87893210ff4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Russellville Intermediate School",
      "poi_type": "Education",
      "poi_address": "1201 W 4th Pl, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-68d8-7086-aef3-4d71232a513a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-68d8-7086-aef3-4d71232a513a",
        "storage_key": "property/6737460151192638/019e1de1-68d8-7086-aef3-4d71232a513a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.russellvilleschools.net/o/ue5g",
      "poi_directions_map_url": "https://maps.google.com/?cid=13161994655988872237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russellville-intermediate-school",
      "poi_latitude": "35.2739335",
      "poi_longitude": "-93.1447095",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-968-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeall_ZpTzIcRLXTOhWfMqLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6b412c08-cf62-47fa-af96-4f3345f96393",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Sequoyah Elementary",
      "poi_type": "Education",
      "poi_address": "1601 W 12th St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6a74-70da-8372-9d561fb5cbe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6a74-70da-8372-9d561fb5cbe6",
        "storage_key": "property/6737460151192638/019e1de1-6a74-70da-8372-9d561fb5cbe6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.russellvilleschools.net/o/seq",
      "poi_directions_map_url": "https://maps.google.com/?cid=1231748804049925115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sequoyah-elementary",
      "poi_latitude": "35.2675442",
      "poi_longitude": "-93.1493449",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-968-2134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJseWn2o5TzIcR-3Po3QINGBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_adeb86cc-66da-4d11-a360-d2b5caa68d29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Oakland Heights Elementary",
      "poi_type": "Education",
      "poi_address": "1501 S Detroit Ave, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.russellvilleschools.net/o/oh",
      "poi_directions_map_url": "https://maps.google.com/?cid=11888231659605221797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakland-heights-elementary",
      "poi_latitude": "35.2649052",
      "poi_longitude": "-93.1287228",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-968-2084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhRvoAn1TzIcRpWFSNrV7-6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_832f1908-f7b5-41c6-8fee-fd39f8217bc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Crawford Elementary School",
      "poi_type": "Education",
      "poi_address": "1116 N Parker Rd, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6c7f-7328-84dd-4c03c6b18627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6c7f-7328-84dd-4c03c6b18627",
        "storage_key": "property/6737460151192638/019e1de1-6c7f-7328-84dd-4c03c6b18627.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.russellvilleschools.net/o/cr",
      "poi_directions_map_url": "https://maps.google.com/?cid=12828029593762385357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crawford-elementary-school",
      "poi_latitude": "35.2893416",
      "poi_longitude": "-93.1216941",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-968-4677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF_F5FxRTzIcRzc1nIPNQBrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b6a16e10-104e-4898-9a92-4f2bee58c498",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Noah's Ark Learning Center",
      "poi_type": "Education",
      "poi_address": "124 E G St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rfalife.com/noahs-ark-learning-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2297664971052598689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noahs-ark-learning-center",
      "poi_latitude": "35.2838363",
      "poi_longitude": "-93.132916",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-890-9422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLeNcUwtTzIcRocVyHB7y4h8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_24a5c8b4-ef53-49bd-8916-807db3ff1b13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Valley Christian Preschool",
      "poi_type": "Education",
      "poi_address": "1609 S Dayton Ave, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6c1b-7453-a399-32706246e113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6c1b-7453-a399-32706246e113",
        "storage_key": "property/6737460151192638/019e1de1-6c1b-7453-a399-32706246e113.webp",
        "width": 968,
        "height": 889
      },
      "poi_business_url": "https://vcsriverhawks.com/vcs-preschool/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17578836782256032530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-christian-preschool",
      "poi_latitude": "35.26299059999999",
      "poi_longitude": "-93.1040014",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-857-9115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4YmKlVZVzIcREgvxsuqS9PM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_caea2a40-204a-4264-b101-15d6c709cf6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "UEC Theatres 11",
      "poi_type": "Entertainment",
      "poi_address": "3800 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Movie theater chain featuring stadium seating, reclining chairs and 3D screenings, plus an arcade.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6d24-739a-8e1c-8896e73bee18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6d24-739a-8e1c-8896e73bee18",
        "storage_key": "property/6737460151192638/019e1de1-6d24-739a-8e1c-8896e73bee18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uecmovies.com/movie-theatres/arkansas/russellville/uec-russellville",
      "poi_directions_map_url": "https://maps.google.com/?cid=9748333987977922166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uec-theatres-11",
      "poi_latitude": "35.2918893",
      "poi_longitude": "-93.1648476",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-967-8126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c5f-7468-8bd7-f73947dc25f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c5f-7468-8bd7-f73947dc25f8",
        "storage_key": "property/6737460151192638/019e1de1-9c5f-7468-8bd7-f73947dc25f8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-f7PrMVTzIcRdoZK-RwKSYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d9e09539-9a7a-4713-9df5-0efe95c6975b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Strikers Bowling Alley",
      "poi_type": "Entertainment",
      "poi_address": "3700 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Family-friendly bowling alley with a snack bar, arcade, and leagues.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6cd0-77ea-b714-35a0e8e0a06f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6cd0-77ea-b714-35a0e8e0a06f",
        "storage_key": "property/6737460151192638/019e1de1-6cd0-77ea-b714-35a0e8e0a06f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://strikersbowling.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15260216793789722463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strikers-bowling-alley",
      "poi_latitude": "35.2907141",
      "poi_longitude": "-93.1648562",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-968-0877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-gRQwVTzIcRX29JZVIux9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_6a5bb5e0-fa53-4b46-91fe-3ccc2d326aba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "The Old Bank",
      "poi_type": "Entertainment",
      "poi_address": "218 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Relaxed bistro and sports bar (and erstwhile bank) serving burgers and steaks, plus cocktails and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-5be7-75dd-8733-78a96333a5e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-5be7-75dd-8733-78a96333a5e8",
        "storage_key": "property/6737460151192638/019e1de1-5be7-75dd-8733-78a96333a5e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://theoldbankrussellville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7231583687429537611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-old-bank",
      "poi_latitude": "35.27863",
      "poi_longitude": "-93.1350241",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-219-5181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687c-745d-8fa6-caac295b97f6",
        "storage_key": "property/6737460151192638/019e1ddf-687c-745d-8fa6-caac295b97f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdRCmgXZTzIcRSz-_lAy_W2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3b40edf3-4f75-4a7a-9693-f2983ac0648b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Handlebar Downtown",
      "poi_type": "Entertainment",
      "poi_address": "115 N Commerce Ave, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-6f29-73ab-89b6-0a2a2c8cbeba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-6f29-73ab-89b6-0a2a2c8cbeba",
        "storage_key": "property/6737460151192638/019e1de1-6f29-73ab-89b6-0a2a2c8cbeba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://handlebardowntown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17603198525613482509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "handlebar-downtown",
      "poi_latitude": "35.2791085",
      "poi_longitude": "-93.1353189",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-449-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c1d-7308-8d91-d8042c63f285.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c1d-7308-8d91-d8042c63f285",
        "storage_key": "property/6737460151192638/019e1de1-9c1d-7308-8d91-d8042c63f285.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-04SbgBTzIcRDSLfFcsfS_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_e3fbce62-6ef8-4620-be95-b1751f6dde27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Arkansas Tech Museum",
      "poi_type": "Entertainment",
      "poi_address": "1502 N El Paso Ave, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14921953472269876998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-tech-museum",
      "poi_latitude": "35.2935654",
      "poi_longitude": "-93.1366256",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-964-0826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c6b-710c-8c16-6ace46ac2c7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c6b-710c-8c16-6ace46ac2c7b",
        "storage_key": "property/6737460151192638/019e1de1-9c6b-710c-8c16-6ace46ac2c7b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69Kh9qdTzIcRBn-NhZ9tFc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_668c9476-d1e8-4f43-926c-e7c03509cfe5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Witherspoon",
      "poi_type": "Entertainment",
      "poi_address": "Witherspoon, 407 W Q St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17073741535985234496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "witherspoon",
      "poi_latitude": "35.2963409",
      "poi_longitude": "-93.1382802",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX2Qon55TzIcRQHI7Z3cd8uw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e963388c-6196-4b03-870a-2d1b74fefa05",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Retro Roasts",
      "poi_type": "Entertainment",
      "poi_address": "Inside Dog Ear Books, 312 W 2nd St, Russellville, AR 72801, USA",
      "poi_short_description": "Coffeehouse, in a retro-style space with an upstairs seating area and an espresso bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-70a2-748d-98fc-ea35ad4345db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-70a2-748d-98fc-ea35ad4345db",
        "storage_key": "property/6737460151192638/019e1de1-70a2-748d-98fc-ea35ad4345db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.retroroasts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14025954769533897116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "retro-roasts",
      "poi_latitude": "35.2779466",
      "poi_longitude": "-93.1359166",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-219-9155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c1f-7020-b224-31a16a3acae3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c1f-7020-b224-31a16a3acae3",
        "storage_key": "property/6737460151192638/019e1de1-9c1f-7020-b224-31a16a3acae3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJd3VNb_JTzIcRnInD2YwzpsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_454f6398-48ca-4253-b87b-172a4c942c50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Arkansas River Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "1799 Lock and Dam Rd, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-7125-779a-96b8-f8a439bafdba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-7125-779a-96b8-f8a439bafdba",
        "storage_key": "property/6737460151192638/019e1de1-7125-779a-96b8-f8a439bafdba.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7934915544166666429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-river-visitor-center",
      "poi_latitude": "35.25247950000001",
      "poi_longitude": "-93.1666998",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1apQZhpVzIcRvZDHfKV7Hm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_1a95ddf6-1d07-4842-9291-24d5c62d6dbf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Potts Inn Museum",
      "poi_type": "Entertainment",
      "poi_address": "15 2nd St, Pottsville, AR 72858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-77af-70f6-b15c-c25accc8f6b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-77af-70f6-b15c-c25accc8f6b3",
        "storage_key": "property/6737460151192638/019e1de1-77af-70f6-b15c-c25accc8f6b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pottsinnmuseum.weebly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15461616559417509870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "potts-inn-museum",
      "poi_latitude": "35.2493102",
      "poi_longitude": "-93.0468027",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-968-8369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c6b-710c-8c16-6ace46ac2c7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c6b-710c-8c16-6ace46ac2c7b",
        "storage_key": "property/6737460151192638/019e1de1-9c6b-710c-8c16-6ace46ac2c7b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfvEbpqrzYcR7sdgdVeyktY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9229c539-8cb0-4324-ada0-afc43225dbde",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Saint Mary's Regional Health System",
      "poi_type": "Health and Wellness",
      "poi_address": "1808 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-52f1-721f-9cbd-fc7e236f2690.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-52f1-721f-9cbd-fc7e236f2690",
        "storage_key": "property/6737460151192638/019e1ddf-52f1-721f-9cbd-fc7e236f2690.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintmarysregional.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12917085561274775560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-marys-regional-health-system",
      "poi_latitude": "35.2835311",
      "poi_longitude": "-93.1501268",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-968-2841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6885-709e-8c69-c61dfb9c15c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6885-709e-8c69-c61dfb9c15c9",
        "storage_key": "property/6737460151192638/019e1ddf-6885-709e-8c69-c61dfb9c15c9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJzbH92JdTzIcRCDgcXeG0QrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_313e1aa0-bdea-4997-be11-c44f93f88b6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Baptist Health Urgent Care - Russellville, Weir Rd.",
      "poi_type": "Health and Wellness",
      "poi_address": "106 Weir Rd #4, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-7179-724f-9d14-9f9b97e7c522.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-7179-724f-9d14-9f9b97e7c522",
        "storage_key": "property/6737460151192638/019e1de1-7179-724f-9d14-9f9b97e7c522.webp",
        "width": 750,
        "height": 422
      },
      "poi_business_url": "https://www.urgentteam.com/locations/baptist-health-urgent-care-russellville-weir-rd-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7902068987476638981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-urgent-care---russellville-weir-rd",
      "poi_latitude": "35.2788117",
      "poi_longitude": "-93.1064352",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-567-5652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5hnSE9TzIcRBf0sjeDJqW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_dabf090e-8a09-47de-9d2f-8e336e537a91",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2409 E Main St, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-72b8-753a-a9fc-c9618c93dd13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-72b8-753a-a9fc-c9618c93dd13",
        "storage_key": "property/6737460151192638/019e1de1-72b8-753a-a9fc-c9618c93dd13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/58-russellville-ar/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10986476969370497713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.2801874",
      "poi_longitude": "-93.1045944",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-968-2970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c72-769e-893d-aee7494850a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c72-769e-893d-aee7494850a7",
        "storage_key": "property/6737460151192638/019e1de1-9c72-769e-893d-aee7494850a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfmBIU9TzIcRsbJWRJjOd5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f2687b78-dc59-4657-a4cd-1bd1c1f4d894",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "101 E Main St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-74fe-754d-9bfc-ab9f57fffcbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-74fe-754d-9bfc-ab9f57fffcbc",
        "storage_key": "property/6737460151192638/019e1de1-74fe-754d-9bfc-ab9f57fffcbc.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/russellville-ar-pharmacies/101-east-main-street-russellville-ar-72801/storeid=11093?WT.mc_id=LS_GOOGLE_RX_11093",
      "poi_directions_map_url": "https://maps.google.com/?cid=1051417354981297961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.2784691",
      "poi_longitude": "-93.1332375",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-498-0014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c72-769e-893d-aee7494850a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c72-769e-893d-aee7494850a7",
        "storage_key": "property/6737460151192638/019e1de1-9c72-769e-893d-aee7494850a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XEpqXZTzIcRKU9XgoNilw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c632e1e3-43c2-45cd-a768-4948bdcb90d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 E Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-7af1-754e-83e8-f5f44cebd649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-7af1-754e-83e8-f5f44cebd649",
        "storage_key": "property/6737460151192638/019e1de1-7af1-754e-83e8-f5f44cebd649.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1100+e+main+st-russellville-ar-72801/id=10199",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996105425050191190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "35.2778046",
      "poi_longitude": "-93.1195138",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-967-1573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c72-769e-893d-aee7494850a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c72-769e-893d-aee7494850a7",
        "storage_key": "property/6737460151192638/019e1de1-9c72-769e-893d-aee7494850a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cN38lVTzIcRVsVY6k6Xsxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_b6543a73-d7cb-48b2-b708-6d63e50d74a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "405 N Arkansas Ave, Russellville, AR 72801, USA",
      "poi_short_description": "Basic gym featuring tanning beds and massage chairs and tables (some hydro).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-4ad8-76e5-b2a9-c43efc143335.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-4ad8-76e5-b2a9-c43efc143335",
        "storage_key": "property/6737460151192638/019e1ddf-4ad8-76e5-b2a9-c43efc143335.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/russellville-ar?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2460781602121118578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.2821381",
      "poi_longitude": "-93.1347711",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-498-9559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhT9AiXRTzIcRcvM-UNRzJiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5dc78865-ec53-4045-aac7-643359d49e66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2005 N Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Chain health club at University Plaza offering a variety of equipment, personal training, and 24-hour access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-770f-75a9-a15c-4673533b8ab6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-770f-75a9-a15c-4673533b8ab6",
        "storage_key": "property/6737460151192638/019e1de1-770f-75a9-a15c-4673533b8ab6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/russellville-arkansas-4395/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4395",
      "poi_directions_map_url": "https://maps.google.com/?cid=16473784382417466426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.3013624",
      "poi_longitude": "-93.1382426",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-957-9156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdebD6pTzIcROvReLJ2jnuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a918463c-62bc-4647-adfc-83bef769d28c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "CrossFit Russellville",
      "poi_type": "Health and Wellness",
      "poi_address": "1509 E Main St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-7ad7-72fd-8153-cfbacbf68d35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-7ad7-72fd-8153-cfbacbf68d35",
        "storage_key": "property/6737460151192638/019e1de1-7ad7-72fd-8153-cfbacbf68d35.webp",
        "width": 1242,
        "height": 670
      },
      "poi_business_url": "https://www.facebook.com/CrossFitRussellville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1757830924545435281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-russellville",
      "poi_latitude": "35.2790735",
      "poi_longitude": "-93.1141406",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-794-9291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWg83UNTzIcRkSa6mOkRZRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6fc2a622-9645-4cd5-aa78-982e3f862658",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Hoft's Maxx Nutrition & Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E 3rd St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-7b36-7129-8ef2-080364e7e344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-7b36-7129-8ef2-080364e7e344",
        "storage_key": "property/6737460151192638/019e1de1-7b36-7129-8ef2-080364e7e344.webp",
        "width": 991,
        "height": 557
      },
      "poi_business_url": "https://www.facebook.com/hoftsMaxxNutrition/?locale=lt_LT",
      "poi_directions_map_url": "https://maps.google.com/?cid=10293325089811661777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hofts-maxx-nutrition--fitness",
      "poi_latitude": "35.2755631",
      "poi_longitude": "-93.1303695",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 540-660-9023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ18fs-HBTzIcR0QPX_6E82Y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3e567849-e747-4844-bf8c-294c70374aee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "JB Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "121 E Harrell Dr #7, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-7f1a-74f8-8010-12ff45ba067e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-7f1a-74f8-8010-12ff45ba067e",
        "storage_key": "property/6737460151192638/019e1de1-7f1a-74f8-8010-12ff45ba067e.webp",
        "width": 1280,
        "height": 1066
      },
      "poi_business_url": "https://jbwellness-rsvl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10961202334678155896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jb-wellness",
      "poi_latitude": "35.3029868",
      "poi_longitude": "-93.1344976",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-716-9371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsZBd8cBTzIcReIKszXIDHpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c1b3ddac-2810-4dea-8b18-c8704258a227",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Lake Dardanelle State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 State Park Drive, Russellville, AR 72802, USA",
      "poi_short_description": "Park offering a visitor center with aquatic exhibits, campgrounds & a fishing tournament pavillion.",
      "poi_long_description": "Park offering a visitor center with aquatic exhibits, campgrounds & a fishing tournament pavillion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-5400-76e8-bb75-ed351c994b58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-5400-76e8-bb75-ed351c994b58",
        "storage_key": "property/6737460151192638/019e1ddf-5400-76e8-bb75-ed351c994b58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arkansasstateparks.com/lakedardanelle/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1136935485062770520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-dardanelle-state-park",
      "poi_latitude": "35.2829931",
      "poi_longitude": "-93.2029827",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-967-5516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJabIm9RZRzIcRWO-zx8w0xw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_51f646a5-3ba8-4287-82c1-a8968f3bb4f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Old Post Park Campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Old Post Park Rd, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-7f0d-750b-9459-7aaee35e3a97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-7f0d-750b-9459-7aaee35e3a97",
        "storage_key": "property/6737460151192638/019e1de1-7f0d-750b-9459-7aaee35e3a97.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.recreation.gov/camping/campgrounds/232662",
      "poi_directions_map_url": "https://maps.google.com/?cid=2154360888182168034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-post-park-campground",
      "poi_latitude": "35.243822",
      "poi_longitude": "-93.1580091",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-968-7962",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c1c-71da-851c-477180af663c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c1c-71da-851c-477180af663c",
        "storage_key": "property/6737460151192638/019e1de1-9c1c-71da-851c-477180af663c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmSCDyhRUzIcR4tkXQtDT5R0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_6a786366-fd41-404e-b2c2-7d7cef49344e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Pleasant View Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3595 N Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Park featuring picnic tables, a playground, athletic fields, a dog park, and a pond stocked with trout in winter.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-5a61-72e3-9b11-93a20dd21c67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-5a61-72e3-9b11-93a20dd21c67",
        "storage_key": "property/6737460151192638/019e1ddf-5a61-72e3-9b11-93a20dd21c67.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.russellvillearkansas.org/Facilities/Facility/Details/Pleasant-View-Park-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=6500758854115100909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pleasant-view-park",
      "poi_latitude": "35.3218533",
      "poi_longitude": "-93.1382493",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-880-1519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJxgtmvhSzIcR7YgBPrxVN1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ccb73157-a0b2-4556-b16e-b588477dc1e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Shiloh Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3501 N Arkansas Ave, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8508-77d3-91b6-7977bfd6be62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8508-77d3-91b6-7977bfd6be62",
        "storage_key": "property/6737460151192638/019e1de1-8508-77d3-91b6-7977bfd6be62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.russellvillearkansas.org/Facilities/Facility/Details/Shiloh-Park-24",
      "poi_directions_map_url": "https://maps.google.com/?cid=4415610298217261780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shiloh-park",
      "poi_latitude": "35.3164827",
      "poi_longitude": "-93.1362865",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 479-968-2098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeCURqtTzIcR1OrL2ytmRz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_766b29df-cea8-4e4e-8fb7-6b9329093210",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "M.J. Hickey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1312 E 16th St, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8176-70fe-b670-4c9b6ed0c531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8176-70fe-b670-4c9b6ed0c531",
        "storage_key": "property/6737460151192638/019e1de1-8176-70fe-b670-4c9b6ed0c531.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.russellvillearkansas.org/Facilities/Facility/Details/MJ-Hickey-Park-17",
      "poi_directions_map_url": "https://maps.google.com/?cid=7503465736364250917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mj-hickey-park",
      "poi_latitude": "35.26240170000001",
      "poi_longitude": "-93.1167867",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwj5C6BUzIcRJVdOCFWqIWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_72e78521-3b5a-460e-87c0-68723e5a085a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Washburn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "72801, 1185 Lake Front Dr, Russellville, AR 72802, USA",
      "poi_short_description": "Charming park known for its waterfront recreation, including boating, fishing & hiking trails.",
      "poi_long_description": "Charming park known for its waterfront recreation, including boating, fishing & hiking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-5b98-778b-90ec-dd910c0c34b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-5b98-778b-90ec-dd910c0c34b6",
        "storage_key": "property/6737460151192638/019e1ddf-5b98-778b-90ec-dd910c0c34b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.russellvillearkansas.org/Facilities/Facility/Details/Washburn-Park-27",
      "poi_directions_map_url": "https://maps.google.com/?cid=12114509584525716524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washburn-park",
      "poi_latitude": "35.3047673",
      "poi_longitude": "-93.1676285",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-968-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8QrV81TzIcRLGy4HUhiH6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_77caf57b-9ad7-43f5-bf3b-d28c52b83ef6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Sequoyah Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1805 W 12th St, Russellville, AR 72801, USA",
      "poi_short_description": "Small, clean local park featuring swings, slides and a playground for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8514-72bb-92b9-2484f2ab6e0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8514-72bb-92b9-2484f2ab6e0d",
        "storage_key": "property/6737460151192638/019e1de1-8514-72bb-92b9-2484f2ab6e0d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.russellvillearkansas.org/Facilities/Facility/Details/Sequoyah-Park-22",
      "poi_directions_map_url": "https://maps.google.com/?cid=6330166110690553304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sequoyah-park",
      "poi_latitude": "35.2678247",
      "poi_longitude": "-93.1514866",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-968-2098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2G5yY5TzIcR2C3t_IlE2Vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_df5fd4b8-3a93-44c8-b476-5f545e34e8ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Confederate Mother's Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Confederate Memorial Park, 1915 S Glenwood Ave, Russellville, AR 72801, USA",
      "poi_short_description": "Memorial park with mountain biking and walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8556-719f-91fe-39bea62bed82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8556-719f-91fe-39bea62bed82",
        "storage_key": "property/6737460151192638/019e1de1-8556-719f-91fe-39bea62bed82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.russellvillearkansas.org/Facilities/Facility/Details/Confederate-Mothers-Memorial-Park-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=6951663939513778772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "confederate-mothers-memorial-park",
      "poi_latitude": "35.2582013",
      "poi_longitude": "-93.140398",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-968-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbCdpAxUzIcRVIKcgIVFeWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_856778e4-27de-44d5-89a9-1b287ee57405",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Bona Dea Trails & Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Scenic 7 Byway, Russellville, AR 72801, USA",
      "poi_short_description": "186-acre park with a protected wetland habitat for native species criss-crossed with trails.",
      "poi_long_description": "186-acre park with a protected wetland habitat for native species criss-crossed with trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-53c0-7075-87f3-7dae464c89e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-53c0-7075-87f3-7dae464c89e0",
        "storage_key": "property/6737460151192638/019e1ddf-53c0-7075-87f3-7dae464c89e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.arkansas.com/attractions/detail.aspx?id=90405",
      "poi_directions_map_url": "https://maps.google.com/?cid=7674509521802103910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bona-dea-trails--sanctuary",
      "poi_latitude": "35.3059534",
      "poi_longitude": "-93.1454674",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-968-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68be-738c-a94b-82a1a53d476b",
        "storage_key": "property/6737460151192638/019e1ddf-68be-738c-a94b-82a1a53d476b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____5tTzIcRZgxesL9VgWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_395b6435-4b49-42b8-a214-f182fb738fdf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Russellville Muni Airport-Rue",
      "poi_type": "Transportation & Transit",
      "poi_address": "1759 Airport Rd, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-5935-762f-bcbf-0e4df17a76e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-5935-762f-bcbf-0e4df17a76e3",
        "storage_key": "property/6737460151192638/019e1ddf-5935-762f-bcbf-0e4df17a76e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.russellvillearkansas.org/149/Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=5500082093123425668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russellville-muni-airport-rue",
      "poi_latitude": "35.2609546",
      "poi_longitude": "-93.0978507",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-967-1227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6879-740c-96dc-7deb344f5225.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6879-740c-96dc-7deb344f5225",
        "storage_key": "property/6737460151192638/019e1ddf-6879-740c-96dc-7deb344f5225.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TK_MFSrzYcRhNUb5IU3VEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ddc5c8c0-032c-474a-ba9f-8594a97849de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Comfort Inn & Suites Russellville I-40",
      "poi_type": "Transportation & Transit",
      "poi_address": "2714 E Parkway Dr, Russellville, AR 72802, USA",
      "poi_short_description": "Straightforward budget hotel offering free hot breakfast & WiFi, plus an indoor pool & gym.",
      "poi_long_description": "Straightforward budget hotel offering free hot breakfast & WiFi, plus an indoor pool & gym.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-88fc-7477-8de2-716a1b9349a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-88fc-7477-8de2-716a1b9349a0",
        "storage_key": "property/6737460151192638/019e1de1-88fc-7477-8de2-716a1b9349a0.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://www.choicehotels.com/arkansas/russellville/comfort-inn-hotels/ar145?mc=llgoxxpx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094264580888289555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comfort-inn--suites-russellville-i-40",
      "poi_latitude": "35.2819547",
      "poi_longitude": "-93.10074600000002",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-968-2424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c81-771a-a9ea-3fdd4fd57b37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c81-771a-a9ea-3fdd4fd57b37",
        "storage_key": "property/6737460151192638/019e1de1-9c81-771a-a9ea-3fdd4fd57b37.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJOZvyrEtTzIcRE2HrAD4J8So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_85b545eb-68b9-451d-b7fa-d9e8ca3972c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Pilot Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "215 AR-331, Russellville, AR 72802, USA",
      "poi_short_description": "Truck stop offering Wi-Fi, showers, and a variety of food and beverage options, plus a Verizon store.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8c6b-77ed-84b2-1e8def37bde9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8c6b-77ed-84b2-1e8def37bde9",
        "storage_key": "property/6737460151192638/019e1de1-8c6b-77ed-84b2-1e8def37bde9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.pilotflyingj.com/us/ar/russellville/215-ar-331-n",
      "poi_directions_map_url": "https://maps.google.com/?cid=7429842447220848737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilot-travel-center",
      "poi_latitude": "35.2806319",
      "poi_longitude": "-93.0927899",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-967-7414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68af-719a-ba34-9b17419d536a",
        "storage_key": "property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv4XFt7aszYcRYbi3O1caHGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_08136516-d684-460e-bb50-d3b0e46ebc4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Arkansas Tech University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "215 W O St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-440f-731c-ba0d-bf68412b896f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddf-440f-731c-ba0d-bf68412b896f",
        "storage_key": "property/6737460151192638/019e1ddf-440f-731c-ba0d-bf68412b896f.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.atu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=782768764910573833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-tech-university",
      "poi_latitude": "35.29378880000001",
      "poi_longitude": "-93.1361472",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-968-0389",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9ySKZghTzIcRCRnEXQv03Ao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1de44b53-ac19-4065-9ffc-28f010e1dcca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Conagra Brands - Russellville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3100 E Main St, Russellville, AR 72802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8f40-7598-927b-59c4b10291f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8f40-7598-927b-59c4b10291f8",
        "storage_key": "property/6737460151192638/019e1de1-8f40-7598-927b-59c4b10291f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.conagrabrands.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=421886832810300805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conagra-brands---russellville",
      "poi_latitude": "35.2751897",
      "poi_longitude": "-93.0942816",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-968-2535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdokxrOszYcRhZUS1dbX2gU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_41c48853-776f-4aca-af49-7cf67e72ad64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Tyson Foods, Russellville Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "702 E Main St, Russellville, AR 72801, USA",
      "poi_short_description": "Chain poultry store offering live unloading, and a driver's lounge.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8ff5-7789-95f2-ee2d1a0f938e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8ff5-7789-95f2-ee2d1a0f938e",
        "storage_key": "property/6737460151192638/019e1de1-8ff5-7789-95f2-ee2d1a0f938e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tyson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15163873342648035977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyson-foods-russellville-distribution-center",
      "poi_latitude": "35.2774912",
      "poi_longitude": "-93.1237081",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-964-4307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-68af-719a-ba34-9b17419d536a",
        "storage_key": "property/6737460151192638/019e1ddf-68af-719a-ba34-9b17419d536a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE4ksyG5TzIcRiSqNp3bmcNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "custom_ba1db70b-b3a2-41ab-9e76-a43cf5d072e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Americold Logistics Russellville Elmira",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 S Elmira Ave, Russellville, AR 72802, USA",
      "poi_short_description": "Cold-storage site for food shipping and receiving, featuring friendly staff and a fenced-in dog area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9302-76de-b24a-f3dd327cc423.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-9302-76de-b24a-f3dd327cc423",
        "storage_key": "property/6737460151192638/019e1de1-9302-76de-b24a-f3dd327cc423.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.americold.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5270698748375469961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "americold-logistics-russellville-elmira",
      "poi_latitude": "35.2741358",
      "poi_longitude": "-93.1048638",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-968-5322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-6876-75ac-b232-27775849cde9",
        "storage_key": "property/6737460151192638/019e1ddf-6876-75ac-b232-27775849cde9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzdDBhE5TzIcRiQ8EF5ZIJUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_51c4cc57-93b6-4a25-ad4b-8748e68e1eea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Pope County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 W Main St, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-8eba-74e7-9969-9934ab0ea5a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-8eba-74e7-9969-9934ab0ea5a8",
        "storage_key": "property/6737460151192638/019e1de1-8eba-74e7-9969-9934ab0ea5a8.webp",
        "width": 1280,
        "height": 649
      },
      "poi_business_url": "http://www.popecountyar.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16238043371910011507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pope-county-courthouse",
      "poi_latitude": "35.2784678",
      "poi_longitude": "-93.1340453",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-968-7499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c87-73bf-9434-4250e5db6946.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c87-73bf-9434-4250e5db6946",
        "storage_key": "property/6737460151192638/019e1de1-9c87-73bf-9434-4250e5db6946.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMaVYo3ZTzIcRcxoV9mkeWeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_e09082e2-8414-4f5e-a593-69f4ed2f9bb9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Russellville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "203 S Commerce Ave, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-93c3-75a8-bb46-812e33a23205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-93c3-75a8-bb46-812e33a23205",
        "storage_key": "property/6737460151192638/019e1de1-93c3-75a8-bb46-812e33a23205.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13573516902591755120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russellville-city-hall",
      "poi_latitude": "35.2773572",
      "poi_longitude": "-93.135385",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-968-2098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c87-73bf-9434-4250e5db6946.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c87-73bf-9434-4250e5db6946",
        "storage_key": "property/6737460151192638/019e1de1-9c87-73bf-9434-4250e5db6946.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMyiu8nZTzIcRcPO9E7XRXrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1f79e0da-8ddd-4c7b-852a-83d53fe5723b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "Russellville School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3115 W 2nd Ct, Russellville, AR 72801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.russellvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6222859144102815784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russellville-school-district",
      "poi_latitude": "35.2849587",
      "poi_longitude": "-93.1672173",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-968-1306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddf-687b-714d-8d40-017912fd1cba",
        "storage_key": "property/6737460151192638/019e1ddf-687b-714d-8d40-017912fd1cba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG22A73hTzIcRKCiK42sJXFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2cde22da-6ec4-465f-833b-7ebaff600df7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "203 S Boston Ave, Russellville, AR 72801, USA",
      "poi_short_description": "Chain post office supplying shipping and mailing, money order, and other services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9118-745d-8951-23291a0e53e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1de1-9118-745d-8951-23291a0e53e6",
        "storage_key": "property/6737460151192638/019e1de1-9118-745d-8951-23291a0e53e6.webp",
        "width": 720,
        "height": 730
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1473452?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=3661770537454585200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "35.27658419999999",
      "poi_longitude": "-93.1316341",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1de1-9c87-73bf-9434-4250e5db6946.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1de1-9c87-73bf-9434-4250e5db6946",
        "storage_key": "property/6737460151192638/019e1de1-9c87-73bf-9434-4250e5db6946.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_sBI3FTzIcRcMX4Jec40TI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_2bac3701-113a-414c-b6da-68899bd27d50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_cc534413-a203-4ce8-86f1-896adec34a7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_71e51166-a63b-4592-b3e7-d35fe84ae645",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e64d0880-0168-4482-b406-ec8384030a86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_39ae9482-ea39-4a44-9c83-aa3f38887751",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_96daad60-5854-4d6d-a2c7-861964513242",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_13907ecb-6613-418c-9c19-6717594586bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "rating": "5",
      "name": "Nicole Domagalski",
      "text": "I have lived here for a year and have loved living at Shiloh Creek apartments. Maintenance is quick to fix any problems and the entire staff is so friendly. Rent isn’t bad either. It’s a quiet and peaceful community. I highly recommend living here.",
      "date": "2025-05-29",
      "title": "false"
    },
    {
      "id": "custom_4e147bf3-5179-42e5-82ee-600ec3dbef10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "rating": "5",
      "name": " Michelle Reddell",
      "text": "I have lived her for a year and a half now and couldn't be happier with my experience. The office staff have been amazing Lisa couldn't be nicer and eager to answer any questions you have. Their maintenance team go above and beyond to make your living experience the best, if approached with an issue they do their best to address your concerns that moment. Jordan and Kyle always have a smile and address you if they see you enjoying the beautiful property and the new lawn maintenance Technician has really done an amazing job and seems to work non stop beautifying this property. Job well done to the Team here. We also welcomed a new property manager named Lisa she is amazing at addressing any concern you may have in a prompt manner. I recommend shiloh creek as your next home!! They have replaced the pool liners and will be ready for 1st day of pool season! Come check it out you won't be sorry.",
      "date": "2026-03-29",
      "title": "false"
    },
    {
      "id": "custom_97b3f277-60da-415a-85e9-756c76a9d624",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "rating": "5",
      "name": "ChurchChoir KY33",
      "text": "The complex manager Lisa is super friendly and helpful. Assistant manager Mechelle and leasing agent Kay are also top notch. The grounds are always well kept and you will see the lawn care folks working 7 days a week. The maintenance crew gets work orders taken care of promptly and have even responded in the middle of the night. This is a very community oriented place with the office personnel establishing a food pantry in the laundry facility and a library currently in the works for residents. There is a sheriff's deputy who lives on site. The pools are clean and great during the summertime. This is just an all around great place to live.",
      "date": "2026-09-29",
      "title": "false"
    },
    {
      "id": "custom_b041e934-8c09-41eb-b698-45e3c0fe8b13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "rating": "5",
      "name": "Anette Juarez - Kimbriel",
      "text": "My partner and I moved to Russellville, AR almost four months ago, so we are still new to moving out on our own and new to the town. Choosing Shiloh Creek Apartments as our place of stay was by far our best choice. Our apartment is very comfy, the area is beautiful, and the amenities provided are awesome! I was taken by surprise by what they do for their community. They send out emails about events they do every month, and they also attach monthly newsletters by the door which is always nice to see in the morning. I have always lived in apartments with my family so events were never a thing until I moved here!\n\nMaintenance is spot on as well. They left my partner and I surprised by how fast they attended to any problem we had. Two months ago, our washer stopped working and when we came home, they had fixed the washer!\n\nWe enjoy our balcony! Small and cute! We are hoping to decorate it soon next summer.\n\nIf you're looking for a place in town, check out Shiloh Creek Apartments! :)",
      "date": "2025-05-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_942643d02ec2dd8866045ef2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019e1ddf-3df6-775a-a650-8c03b95acc50.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1ddf-3df6-775a-a650-8c03b95acc50",
        "storage_key": "property/6737460151192638/019e1ddf-3df6-775a-a650-8c03b95acc50.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6683861199887f11fadcf489"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fd0-fd86-76d8-9d82-d459a81171a9",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-shiloh-creek-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638"
    },
    {
      "lead_collector_id": "0199de11-6941-7080-8340-68f9cd01b0a1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-shiloh-creek-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-russellville-ar",
      "search_query": "luxury apartments with pool in Russellville AR",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Russellville, AR",
      "h2_subtitle": "Experience the best of Russellville living in luxury. Enjoy our refreshing pool among other exceptional amenities at Shiloh Creek Apartments.",
      "page_copy": "Welcome to Shiloh Creek Apartments, where luxury meets comfort in Russellville, AR. Our community boasts spacious one and two-bedroom layouts designed with elegance and style in mind. Residents can indulge in a refreshing pool, perfect for unwinding or socializing with neighbors. \n\nOur premier location in the Fort Smith/Russellville I-40 neighborhood offers the best of both urban convenience and serene living. At Shiloh Creek Apartments, amenities include a modern fitness center and inviting clubhouse, ensuring a superior living experience. Schedule a visit today to explore these luxury apartments with pool in Russellville, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
      "featured_image_media": {
        "alt_text": "1-bedroom, 1-bathroom floor plan",
        "public_id": "019d0784-730f-7738-99c6-3000d1c995ee",
        "storage_key": "property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
        "width": 750,
        "height": 750
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Russellville, AR",
      "seo_description": "Discover luxury living with a pool at Shiloh Creek Apartments in Russellville, AR. Explore our spacious floor plans and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "page_item_url": "shiloh-creek-furnished-units-air-conditioning",
      "search_query": "Shiloh Creek furnished units with air conditioning",
      "category": "Amenity",
      "h1_title": "Shiloh Creek Furnished Units with Air Conditioning",
      "h2_subtitle": "Comfort meets convenience in Shiloh Creek's furnished units. Enjoy air conditioning and a range of amenities in Russellville, AR.",
      "page_copy": "Discover the convenience and comfort at Shiloh Creek Apartments with our furnished units, perfect for those seeking an all-inclusive living experience in Russellville, AR. Each unit comes equipped with air conditioning, providing a cool, relaxing environment during the warm Arkansas summers.\n\nPositioned within the Fort Smith/Russellville I-40 neighborhood, Shiloh Creek offers an array of top-notch amenities, including a refreshing pool and a fitness center. Whether you're settling in for the long term or need a temporary place that feels like home, explore our air-conditioned furnished units today. Experience living redefined at Shiloh Creek Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
      "featured_image_media": {
        "alt_text": "1-bedroom, 1-bathroom floor plan",
        "public_id": "019d0784-730f-7738-99c6-3000d1c995ee",
        "storage_key": "property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
        "width": 750,
        "height": 750
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Shiloh Creek Furnished Units with A/C",
      "seo_description": "Find air-conditioned furnished units at Shiloh Creek Apartments in Russellville, AR. Enjoy convenience and comfort with our furnished options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-pope-county",
      "search_query": "apartments with fitness center in Pope County",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Pope County",
      "h2_subtitle": "Stay active at Shiloh Creek Apartments in Pope County. Our state-of-the-art fitness center awaits you in Russellville, AR.",
      "page_copy": "Looking for a vibrant lifestyle in Pope County? Shiloh Creek Apartments in Russellville offer residents access to a modern fitness center, perfect for maintaining a healthy lifestyle. With spacious one and two-bedroom floor plans, our community blends comfort and convenience.\n\nNestled in the Fort Smith/Russellville I-40 neighborhood, our apartments provide a peaceful retreat with easy access to city amenities. In addition to our state-of-the-art fitness center, enjoy features like a refreshing pool and a business center. Come visit us and discover the ideal place to call home in Pope County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
      "featured_image_media": {
        "alt_text": "1-bedroom, 1-bathroom floor plan",
        "public_id": "019d0784-730f-7738-99c6-3000d1c995ee",
        "storage_key": "property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
        "width": 750,
        "height": 750
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Pope County",
      "seo_description": "Discover Shiloh Creek Apartments in Pope County, featuring a modern fitness center and spacious layouts in Russellville, AR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-clubhouse-72802",
      "search_query": "smoke-free apartments with clubhouse in 72802",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments with Clubhouse in 72802",
      "h2_subtitle": "Enjoy a clean, smoke-free environment at Shiloh Creek Apartments. Discover our inviting clubhouse at the heart of Russellville, AR.",
      "page_copy": "Experience a healthier lifestyle at Shiloh Creek Apartments, offering smoke-free living in Russellville's 72802 zip code. Our community is dedicated to providing a fresh, clean environment enhanced by a welcoming clubhouse, ideal for socializing and relaxing with neighbors.\n\nLocated in the desirable Fort Smith/Russellville I-40 neighborhood, Shiloh Creek Apartments feature a variety of amenities to elevate your living experience, including a refreshing pool and state-of-the-art fitness center. Choose from spacious one and two-bedroom floor plans and find your new smoke-free home today. Visit us to see what sets Shiloh Creek apart in Russellville, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
      "featured_image_media": {
        "alt_text": "1-bedroom, 1-bathroom floor plan",
        "public_id": "019d0784-730f-7738-99c6-3000d1c995ee",
        "storage_key": "property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
        "width": 750,
        "height": 750
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments with Clubhouse in 72802",
      "seo_description": "Live at Shiloh Creek Apartments in 72802. Our smoke-free community offers a welcoming clubhouse and spacious layouts in Russellville, AR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "page_item_url": "russellville-ar-apartments-business-center",
      "search_query": "Russellville AR apartments with business center",
      "category": "Amenity",
      "h1_title": "Russellville AR Apartments with Business Center",
      "h2_subtitle": "Shiloh Creek Apartments offer a modern business center in Russellville, AR. Elevate your living experience with our on-site amenities.",
      "page_copy": "Nestled in the heart of Russellville, AR, Shiloh Creek Apartments provide residents with a state-of-the-art business center, perfect for remote work or study sessions. Our community understands the importance of convenience and productivity, making us an ideal choice for those seeking both comfort and functionality.\n\nIncluding a host of luxurious amenities, such as a refreshing pool and a fitness center, Shiloh Creek Apartments offer the best in apartment living in the Pope County area. With spacious one and two-bedroom options available, our community is designed to meet your every need. Schedule a tour today and discover why Shiloh Creek is the premier choice for apartments with a business center in Russellville, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
      "featured_image_media": {
        "alt_text": "1-bedroom, 1-bathroom floor plan",
        "public_id": "019d0784-730f-7738-99c6-3000d1c995ee",
        "storage_key": "property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
        "width": 750,
        "height": 750
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Russellville AR Apartments with Business Center",
      "seo_description": "Discover Shiloh Creek Apartments in Russellville, AR, offering a modern business center and luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-russellville-ar",
      "search_query": "one bedroom apartments in Russellville AR",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Russellville AR",
      "h2_subtitle": "Explore one-bedroom apartments at Shiloh Creek in Russellville, AR. Discover our luxurious living spaces and premium amenities.",
      "page_copy": "At Shiloh Creek Apartments, we offer elegant one-bedroom apartments in the vibrant city of Russellville, AR. Our thoughtfully designed floor plans provide a perfect balance of style and comfort, making your home a sanctuary.\n\nLocated in the Fort Smith/Russellville I-40 neighborhood, our community is filled with first-class amenities, including a refreshing pool, a state-of-the-art fitness center, and an inviting clubhouse. Experience the convenience of living near bustling city life while enjoying the serenity of a peaceful environment. Visit Shiloh Creek Apartments and find your ideal one-bedroom apartment in Russellville today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
      "featured_image_media": {
        "alt_text": "1-bedroom, 1-bathroom floor plan",
        "public_id": "019d0784-730f-7738-99c6-3000d1c995ee",
        "storage_key": "property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
        "width": 750,
        "height": 750
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Russellville AR",
      "seo_description": "Discover one-bedroom apartments at Shiloh Creek in Russellville, AR. Enjoy luxurious amenities and stylish living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192638",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-fort-smith-russellville-i40",
      "search_query": "two bedroom apartments near Fort Smith Russellville I-40",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments near Fort Smith Russellville I-40",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Shiloh Creek, conveniently located near Fort Smith and Russellville I-40.",
      "page_copy": "Welcome to Shiloh Creek Apartments, where spacious two-bedroom units await near Fort Smith and the Russellville I-40 corridor. Our community offers the perfect blend of convenience and comfort, providing easy access to local amenities and attractions.\n\nEach two-bedroom apartment is designed with your lifestyle in mind, featuring modern finishes and plenty of room to make it your own. Enjoy the tranquility of our serene courtyard, take advantage of our state-of-the-art fitness center, or relax by the pool. Experience the best of both worlds with a home that’s close to city conveniences while surrounded by peaceful surroundings. Schedule a tour today and see why Shiloh Creek is an ideal choice for two-bedroom apartments near Fort Smith Russellville I-40.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
      "featured_image_media": {
        "alt_text": "1-bedroom, 1-bathroom floor plan",
        "public_id": "019d0784-730f-7738-99c6-3000d1c995ee",
        "storage_key": "property/6737460151192638/019d0784-730f-7738-99c6-3000d1c995ee.webp",
        "width": 750,
        "height": 750
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments near Fort Smith Russellville I-40",
      "seo_description": "Find spacious two-bedroom apartments at Shiloh Creek, near Fort Smith Russellville I-40. Enjoy modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3405"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483427"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4871561"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T2R9W55G"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "479-370-1267"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "479-324-2117"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "479-342-2673"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "479-346-0967"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "479-370-1731"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "479-348-1688"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "479-315-6177"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "479-315-6198"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "479-348-1091"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "479-259-1272"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "479-888-4539"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "479-329-1480"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "479-448-2864"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "479-448-4176"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "479-408-4834"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "479-370-1742"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "479-777-8166"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321118532"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "479-385-0681"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "479-244-2298"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e155ce6160011eec"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "479-391-4292"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "479-346-2790"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "479-370-1494"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "479-341-1334"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "479-334-0965"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "479-370-1714"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "479-370-1532"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "479-349-2775"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.livingatshilohcreek.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192638/019e84a6-7b7f-75fa-8de0-a95175683996.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "479-370-1634"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "479-259-1272"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3405",
  "custom_repli_id": "5028483427",
  "custom_realpage_id": "4871561",
  "custom_knock_a_link": "https://www.livingatshilohcreek.com?utm_knock=a",
  "custom_knock_g_link": "https://www.livingatshilohcreek.com?utm_knock=g",
  "custom_knock_r_link": "https://www.livingatshilohcreek.com?utm_knock=r",
  "custom_knock_w_link": "https://www.livingatshilohcreek.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-T2R9W55G",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.livingatshilohcreek.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.livingatshilohcreek.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.livingatshilohcreek.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.livingatshilohcreek.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.livingatshilohcreek.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.livingatshilohcreek.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "479-370-1267",
  "custom_knock_ads_link": "https://www.livingatshilohcreek.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.livingatshilohcreek.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "479-324-2117",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.livingatshilohcreek.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.livingatshilohcreek.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.livingatshilohcreek.com?utm_knock=ppn",
  "custom_knock_r_number": "479-342-2673",
  "custom_knock_w_number": "479-346-0967",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "479-370-1731",
  "custom_knock_amap_link": "https://www.livingatshilohcreek.com?utm_knock=amap",
  "custom_knock_ar_number": "479-348-1688",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "479-315-6177",
  "custom_knock_fb_number": "479-315-6198",
  "custom_knock_fl_number": "479-348-1091",
  "custom_knock_gp_number": "479-259-1272",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.livingatshilohcreek.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "479-888-4539",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.livingatshilohcreek.com?utm_knock=bcard",
  "custom_knock_bnr_number": "479-329-1480",
  "custom_knock_cfres_link": "https://www.livingatshilohcreek.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "479-448-2864",
  "custom_knock_lgp_number": "479-448-4176",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.livingatshilohcreek.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "479-408-4834",
  "custom_knock_psocl_link": "https://www.livingatshilohcreek.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "479-370-1742",
  "custom_knock_bandit_link": "https://www.livingatshilohcreek.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.livingatshilohcreek.com?utm_knock=flyers",
  "custom_knock_osoc_number": "479-777-8166",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321118532",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "479-385-0681",
  "custom_knock_cfres_number": "479-244-2298",
  "custom_knock_chatgpt_link": "https://www.livingatshilohcreek.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "e155ce6160011eec",
  "custom_knock_dirmail_link": "https://www.livingatshilohcreek.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "479-391-4292",
  "custom_knock_propbro_link": "https://www.livingatshilohcreek.com?utm_knock=propbro",
  "custom_knock_psocl_number": "479-346-2790",
  "custom_knock_bandit_number": "479-370-1494",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "479-341-1334",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.livingatshilohcreek.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "479-334-0965",
  "custom_knock_dirmail_number": "479-370-1714",
  "custom_knock_propbro_number": "479-370-1532",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "479-349-2775",
  "custom_knock_maintenance_link": "https://www.livingatshilohcreek.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192638/019e84a6-7b7f-75fa-8de0-a95175683996.mp4",
  "custom_knock_maintenance_number": "479-370-1634",
  "custom_ppc_tracking_phone_number": "479-259-1272",
  "custom_audioeye_site_id": "03ff1d3e-147a-47e9-991d-b1e1aab89682",
  "custom_audioeye_site_hash": "e08a296cee1b2fbaf2ad6a7078b4c151"
};

export const generatedAt = '2026-11-03T22:08:50.922Z';
